import PlayMode from "../model/PlayMode";
import GlobalPlatformParameters from "./GlobalPlatformParameters";

export default class AppPlatformParameters {

    constructor(language, interactionState, playMode, environment, payload) {
        this._language = language;
        this._state = interactionState;
        this._playMode = playMode;
        this._environment = environment;
        this._payload = payload;
    }

    /**
     * @returns {Object} Generic object containing game state (savegame) or null
     */
    get state() {
        return this._state;
    }

    /**
     * @returns {String} Language id
     */
    get language() {
        return this._language;
    }

    /**
     * @returns {PlayMode} Playmode: assessment or demo
     */
    get playMode() {
        return this._playMode;
    }

    get environment() {
        return this._environment;
    }

    /**
     * @param {Object} obj 
     * @returns {AppPlatformParameters} 
     */
    static fromObject(obj) {
        return new AppPlatformParameters(
            obj.language,
            JSON.parse(obj.interaction_state),
            GlobalPlatformParameters.parsePlayMode(obj.play_mode),
            obj.environment,
            obj
        );
    }
}

